import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../../hooks";
import * as userActions from "../../../redux/reducers/userReducer";
import { userState } from "../../../redux/reducers/userReducer";

import profile_img from "../../../assets/avatar_placeholder.png";
import calender_black from "../../../assets/calender_black.svg";
import customer_name from "../../../assets/customer_name.svg";
import email_img from "../../../assets/Email.svg";
import lock_img from "../../../assets/password.svg";
import { TwButton, TwCalendarPicker, TwDropzone, TwInputGroup, TwPhoneInputGroup, TwSelectGroup } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading, setSectionLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForUsers } from "../../../utils/confighelpers";
import ChangePassword from "./ChangePassword";
import { getInitialsUrl } from "../../../helpers";
import { useTranslation } from "react-i18next";

export default function ProfileForm(props) {
    const { t, i18n } = useTranslation();
    const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loadingReduxState = useSelector(loadingState);
    const userReduxState = useSelector(userState);
    const [userToken] = useLocalStorage("userToken");
    const [formValues, setFormValues] = React.useState({
        ...userReduxState.userData,
        // gender: "",
        // dob: "",
        password: "..........",
        location: {},
        about: "",
    });
    const [formErrors, setFormErrors] = React.useState({});
    const [passwordVisible, setPasswordVisible] = React.useState(false);
    const [isThereChange, setIsThereChange] = React.useState(true);
    const [showChangePassword, setShowChangePassword] = React.useState(false);

    React.useEffect(() => {
        setTimeout(() => {
            setIsThereChange(true)
        }, 1 * 1000);
    }, [])
    React.useEffect(() => {
        setIsThereChange(false)
    }, [formValues])

    const handleChangePic = async (url) => {
        dispatch(setSectionLoading(true));
        const result = await axiosInstance.put(
            `${getUrlForUsers()}updateProfile`,
            {
                profilePic: url,
            }
        );
        dispatch(setSectionLoading(false));
        if (result.data.statusCode === 200) {
            dispatch(
                userActions.setUserData(
                    Object.assign({}, userReduxState.userData, { profilePic: url }, result.data)
                )
            );
            setFormValues((prevValues) => ({
                ...prevValues,
                profilePic: url,
            }));
            setIsThereChange(true)
        } else {
            addErrorToast(result.data.message);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        const errors = {};
        if (!formValues.fullName) {
            errors.fullName = t("errors.required");
        }
        if (!formValues.email) {
            errors.email = t("errors.required");
        }
        /* 
        if (!formValues.gender) {
            errors.gender = t("errors.required");
        }
        if (!formValues.dob) {
            errors.dob = t("errors.required");
        } */
        setFormErrors({ ...errors }); if (Object.keys(errors).length > 0) {
            dispatch(setActionLoading(false));
            addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
            return;
        }

        let body = {
            fullName: formValues.fullName,
            // email: formValues.email,
            gender: formValues.gender,
            dob: formValues.dob,
        }
        dispatch(setActionLoading(true));
        dispatch(setGlobalLoading(true));
        const result = await axiosInstance.put(
            `${getUrlForUsers()}updateProfile`,
            {
                ...body,
            }
        );
        dispatch(setGlobalLoading(false));
        dispatch(setActionLoading(false));
        if (result.data.statusCode === 200) {
            dispatch(
                userActions.setUserData(
                    Object.assign({}, userReduxState.userData, body)
                )
            );
            addNotificationDialog({
                dialogType: "success",
                dialogTitle: t("linkDescription.success"),
                dialogMessage: t("successes.profileSuccessfully"),
                dialogBtnTitle: t("inputFieldsTitle.ok"),
            })
        } else {
            addErrorToast(result.data.message);
        }

    };

    return (
        <div className={"flex flex-col md:p-3"}>
            <div className="divide-y">
                <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
                    <div>
                        <h2 className="text-base/7 font-semibold">{t("account.loginInformationTitle")}</h2>
                        <p className="mt-1 text-sm/6 text-gray-400">{t("account.loginInformationSubTitle")}</p>
                    </div>
                    <div className={"flex flex-col gap-4 md:col-span-2"}>
                        {userReduxState.userData !== null && userReduxState.userData?.socialType && userReduxState.userData.socialType === "normal" ? (<TwPhoneInputGroup
                            label={t("inputFieldsTitle.username")}
                            placeholder={t("inputFieldsTitle.phoneNumber")}
                            name={"username"}
                            disabled
                            value={formValues.username}
                        />) : (<div className="flex flex-col gap-2">
                            <TwInputGroup
                                label={t("inputFieldsTitle.organizationEmail")}
                                placeholder={t("inputFieldsTitle.contactEmail")}
                                name={"workEmail"}
                                leftIcon={(<img className={""} src={email_img} alt={""} />)}
                                defaultValue={formValues.username}
                                errors={formErrors}
                            />
                            <div className="w-full flex items-center gap-2">
                                <span className="text-sm text-gray-400">{t("account.authenticatedViaGoogle")}  </span>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="20px" height="20px"><linearGradient id="95yY7w43Oj6n2vH63j6HJb" x1="29.401" x2="29.401" y1="4.064" y2="106.734" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#ff5840"></stop><stop offset=".007" stopColor="#ff5840"></stop><stop offset=".989" stopColor="#fa528c"></stop><stop offset="1" stopColor="#fa528c"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJb)" d="M47.46,15.5l-1.37,1.48c-1.34,1.44-3.5,1.67-5.15,0.6c-2.71-1.75-6.43-3.13-11-2.37	c-4.94,0.83-9.17,3.85-11.64, 7.97l-8.03-6.08C14.99,9.82,23.2,5,32.5,5c5,0,9.94,1.56,14.27,4.46	C48.81,10.83,49.13,13.71,47.46,15.5z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJc" x1="12.148" x2="12.148" y1=".872" y2="47.812" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#feaa53"></stop><stop offset=".612" stopColor="#ffcd49"></stop><stop offset="1" stopColor="#ffde44"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJc)" d="M16.01,30.91c-0.09,2.47,0.37,4.83,1.27,6.96l-8.21,6.05c-1.35-2.51-2.3-5.28-2.75-8.22	c-1.06-6.88,0.54-13.38, 3.95-18.6l8.03,6.08C16.93,25.47,16.1,28.11,16.01,30.91z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJd" x1="29.76" x2="29.76" y1="32.149" y2="-6.939" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#42d778"></stop><stop offset=".428" stopColor="#3dca76"></stop><stop offset="1" stopColor="#34b171"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJd)" d="M50.45,51.28c-4.55,4.07-10.61,6.57-17.36,6.71C22.91,58.2,13.66,52.53,9.07,43.92l8.21-6.05	C19.78,43.81, 25.67,48,32.5,48c3.94,0,7.52-1.28,10.33-3.44L50.45,51.28z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJe" x1="46" x2="46" y1="3.638" y2="35.593" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#155cde"></stop><stop offset=".278" stopColor="#1f7fe5"></stop><stop offset=".569" stopColor="#279ceb"></stop><stop offset=".82" stopColor="#2cafef"></stop><stop offset="1" stopColor="#2eb5f0"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJe)" d="M59,31.97c0.01,7.73-3.26,14.58-8.55,19.31l-7.62-6.72c2.1-1.61,3.77-3.71,4.84-6.15 c0.29-0.66-0.2-1.41-0.92-1.41H37c-2.21,0-4-1.79-4-4v-2c0-2.21,1.79-4,4-4h17C56.75,27,59,29.22,59,31.97z"></path></svg>
                            </div>
                        </div>)}
                        {userReduxState.userData !== null && userReduxState.userData?.socialType && userReduxState.userData.socialType === "normal" && (showChangePassword ? (
                            <ChangePassword
                                onCancel={() => {
                                    setShowChangePassword(false);
                                }}
                            />) : (<div className="flex flex-col gap-4">
                                <TwInputGroup
                                    label={t("inputFieldsTitle.password")}
                                    placeholder={t("inputFieldsTitle.passwordPlaceholder")}
                                    name={"password"}
                                    disabled
                                    type={passwordVisible ? "text" : "password"}
                                    leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                                    value={formValues.password}
                                    onChange={handleInputChange}
                                    errors={formErrors}
                                />
                                <div className={"flex flex-row items-center gap-2"}>
                                    <TwButton
                                        className="sm:min-w-32"
                                        variant={"danger-outline"}
                                        onClick={() => { setShowChangePassword(true); }}
                                    >
                                        {t("account.changePassword")}
                                    </TwButton>
                                </div>
                            </div>))}
                    </div>
                </div>
                <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
                    <div>
                        <h2 className="text-base/7 font-semibold">{t("account.personalInformationTitle")}</h2>
                        <p className="mt-1 text-sm/6 text-gray-400">{t("account.personalInformationSubTitle")}</p>
                    </div>
                    <div className={"flex flex-col gap-4 md:col-span-2"}>
                        <div className={"grid place-items-start mb-2 md:max-w-lg"}>
                            <TwDropzone
                                // label={"Your Logo"}
                                variant={"profile"}
                                name={"profilePic"}
                                uploadBtnText={t("account.changeProfileBtn")}
                                defaultValue={profile_img}
                                value={formValues?.profilePic}
                                errors={formErrors}
                                onChange={(image) => {
                                    if (image) {
                                        handleChangePic(image);
                                    }
                                }}
                                isShowDeletBtn={true}
                                onDelete={() => {
                                    if (formValues.fullName) {
                                        handleChangePic(getInitialsUrl(formValues.fullName));
                                    }
                                }}
                            />
                            {/* {formErrors["profilePic"] && (
                                <TwFormHelperText error={formErrors?.profilePic !== ""}>{formErrors["profilePic"]}</TwFormHelperText>
                            )} */}
                        </div>
                        <TwInputGroup
                            label={t("inputFieldsTitle.fullName")}
                            placeholder={t("inputFieldsTitle.fullName")}
                            name={"fullName"}
                            leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                            value={formValues.fullName}
                            onChange={handleInputChange}
                            errors={formErrors}
                        />
                        <TwInputGroup
                            label={t("inputFieldsTitle.email")}
                            placeholder={t("inputFieldsTitle.emailAddress")}
                            type={"email"}
                            name={"email"}
                            leftIcon={(<img className={""} src={email_img} alt={""} />)}
                            value={formValues.email}
                            onChange={handleInputChange}
                            errors={formErrors}
                        />
                        <TwSelectGroup label={t("profile.gender")}
                            placeholder={t("profile.SelectGender")}
                            name={"gender"}
                            leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                            options={[
                                { value: "", title: t("profile.SelectGender") },
                                { value: "Male", title: t("profile.male") },
                                { value: "Female", title: t("profile.female") },
                                { value: "Other", title: t("profile.other") },
                            ]}
                            value={formValues.gender}
                            onChange={handleInputChange}
                            errors={formErrors} />
                        <TwCalendarPicker
                            label={t("profile.dateOfbirth")}
                            name={"dob"}
                            leftIcon={(<img className={""} src={calender_black} alt={""} />)}
                            format="MM/DD/YYYY"
                            value={(formValues.dob) ? formValues.dob : null}
                            onChange={(event) => {
                                const newValue = event?.toDate();
                                setFormValues((prevValues) => ({
                                    ...prevValues,
                                    dob: newValue,
                                }));
                            }}
                            errors={formErrors} />
                        <div className={"flex flex-row items-center gap-2"}>
                            <TwButton
                                variant={"secondary"}
                                className="sm:min-w-32 [md:w-full]"
                                disabled={loadingReduxState.actionLoading || isThereChange}
                                actionLoading={(loadingReduxState.actionLoading)}
                                onClick={handleSubmit}
                            >
                                {t("update")}
                            </TwButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
